import { NavigateFunction } from "react-router-dom";
export const goToUrl =  (urlString: string, openInNewTab: boolean, navigate: NavigateFunction) => {
  const url = new URL(urlString);

  if(window.location.host === url.host) {
    navigate(url.pathname);
  } else {
    window.open(url, openInNewTab ? "_blank" : "_self", "noopener");
  }

}

